import { OctagonOutlineIcon } from './OctagonOutlineIcon';

/**
 * author: Simran
 * id 3CF63E10-42E7-4E13-8BFF-10E9257953AB
 * name octagon-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/octagon-outline.svg
 * tags
 * - Shape 
 * - Transportation + Road 
 */
export const StopOutlineIcon = OctagonOutlineIcon;
export default StopOutlineIcon